/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LineAllocationDto
 */
export interface LineAllocationDto {
    /**
     * OrderItem ID linked to this SupplierBatchLine
     * @type {number}
     * @memberof LineAllocationDto
     */
    orderItemId: number;
    /**
     * Qty allocated to this orderItem. Sum across allocations must equal line.confirmedTotalQty.
     * @type {number}
     * @memberof LineAllocationDto
     */
    allocatedQuantity: number;
}

/**
 * Check if a given object implements the LineAllocationDto interface.
 */
export function instanceOfLineAllocationDto(value: object): value is LineAllocationDto {
    if (!('orderItemId' in value) || value['orderItemId'] === undefined) return false;
    if (!('allocatedQuantity' in value) || value['allocatedQuantity'] === undefined) return false;
    return true;
}

export function LineAllocationDtoFromJSON(json: any): LineAllocationDto {
    return LineAllocationDtoFromJSONTyped(json, false);
}

export function LineAllocationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LineAllocationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'orderItemId': json['orderItemId'],
        'allocatedQuantity': json['allocatedQuantity'],
    };
}

export function LineAllocationDtoToJSON(value?: LineAllocationDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'orderItemId': value['orderItemId'],
        'allocatedQuantity': value['allocatedQuantity'],
    };
}

